import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquized: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquized"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V21H11V3H13ZM5 7.58579L9.41421 12L5 16.4142L3.58579 15L5.58579 13H1V11H5.58579L3.58579 9L5 7.58579ZM20.4142 9L18.4142 11H23V13H18.4142L20.4142 15L19 16.4142L14.5858 12L19 7.58579L20.4142 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquized;
